// Replace ® to <sup>®</sup> - all site

// document.addEventListener('DOMContentLoaded', () => {
//   const walker = document.createTreeWalker(
//     document.body,
//     NodeFilter.SHOW_TEXT,
//     null,
//     false
//   );

//   const textNodes = [];

//   while (walker.nextNode()) {
//     const node = walker.currentNode;

//     // Skip script/style/noscript
//     if (
//       node.parentElement &&
//       !['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(node.parentElement.tagName) &&
//       node.nodeValue.includes('®')
//     ) {
//       textNodes.push(node);
//     }
//   }

//   textNodes.forEach(node => {
//     const span = document.createElement('span');
//     span.innerHTML = node.nodeValue.replace(/®/g, '<sup>®</sup>');
//     node.parentNode.replaceChild(span, node);
//   });
// });
  

// ======================================
// Resource List Carousel Dots
// ======================================

(() => {
  const initialized = new WeakSet();

  function initCarousel(slideshow) {
    if (initialized.has(slideshow)) return;
    initialized.add(slideshow);

    const dotsWrapper = slideshow.nextElementSibling;

    if (!dotsWrapper || !dotsWrapper.classList.contains("slideshow-dots")) return;

    const component = slideshow.closest("slideshow-component");

    if (!component) return;

    // Hide until ready
    dotsWrapper.style.visibility = "hidden";

    function renderDots() {
      const slides = component.slides || [];
      const visibleSlides = component.visibleSlides || [];

      if (!slides.length || !visibleSlides.length) return false;

      const visible = visibleSlides.length;
      const totalPages = Math.max(1, slides.length - visible + 1);
      const currentPage = Math.min(component.current + 1, totalPages);

      // Rebuild only if needed
      if (dotsWrapper.children.length !== totalPages) {
        dotsWrapper.innerHTML = "";

        for (let i = 0; i < totalPages; i++) {
          const dot = document.createElement("button");
          dot.type = "button";
          dot.className = "slideshow-dot";

          dot.addEventListener("click", () => {
            component.select(i);
          });

          dotsWrapper.appendChild(dot);
        }
      }

      dotsWrapper.querySelectorAll(".slideshow-dot").forEach((dot, index) => {
        dot.classList.toggle("is-active", index === currentPage - 1);
      });

      dotsWrapper.style.visibility = "visible";

      return true;
    }

    function waitUntilReady() {
      if (renderDots()) return;

      requestAnimationFrame(waitUntilReady);
    }

    waitUntilReady();

    component.addEventListener("slideshow:select", renderDots);

    window.addEventListener("resize", () => {
      dotsWrapper.style.visibility = "hidden";

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          renderDots();
        });
      });
    });
  }

  function initAll() {
    document
      .querySelectorAll(".resource-list__carousel")
      .forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);

  const observer = new MutationObserver(() => {
    initAll();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();